import src from "IMAGE";
export default { src, width: 24, height: 9, blurWidth: 0, blurHeight: 0};
